import React from 'react'

const Info = () => {
  return (
    <div className='maininfo'>
         <h1 className='hh'>Information</h1>
        <div className='info'>
           
            <div className='finfo'>
<h3 className='iwas' >
    
I was born and raised in Southern California where I grew up in a Lakers town and 
always had good music playing around the house. These threads of family, basketball,
 and music have defined my life path and experiences. I am currently pursuing a Master 
 of Science in Entrepreneurship and Innovation from the University of Southern California’s 
 Marshall School of Business in tandem with being a member on the Trojans Women’s Basketball 
 Team. This follows the completion of my undergraduate degree at the University of Pennsylvania
  where I earned a Bachelor of Science in Economics with concentrations in Finance and Management 
  from the Wharton School of 
Business. At Penn, I was also a four-year member on the Quakers Women’s Basketball Team and two-time captain.
</h3>
            </div>
            <div className='sinfo'>
            <h3 className='iwas'>
    
    I was born and raised in Southern California where I grew up in a Lakers town and 
    always had good music playing around the house. These threads of family, basketball,
     and music have defined my life path and experiences. I am currently pursuing a Master 
     of Science in Entrepreneurship and Innovation from the University of Southern California’s 
     Marshall School of Business in tandem with being a member on the Trojans Women’s Basketball 
     Team. This follows the completion of my undergraduate degree at the University of Pennsylvania
      where I earned a Bachelor of Science in Economics with concentrations in Finance and Management 
      from the Wharton School of 
    Business. At Penn, I was also a four-year member on the Quakers Women’s Basketball Team and two-time captain.
    </h3>
            </div>
        </div>
    </div>
  )
}

export default Info